import { useState, useEffect } from 'react';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getSortedRecords } from '../utils';

function mergeSortInfoWithDefault(sortInfo?: SortByItemType): SortByItemType {
  return {
    key: sortInfo?.key || 'date_0',
    text: sortInfo?.text || 'Date',
    title: sortInfo?.title || 'Date',
    sortMetric: sortInfo?.sortMetric || 'date',
    ratioType: sortInfo?.ratioType || 0,
    sortVal: sortInfo?.sortVal || 'desc',
  };
}

export default function useSort(option?: { sortInfo?: SortByItemType }) {
  const { sortInfo: sortInfoOutter } = option || {};

  const initialSortInfo = mergeSortInfoWithDefault(sortInfoOutter);

  const [sortInfo, setSortInfo] = useState<SortByItemType>(initialSortInfo);

  const handleSortChange = (sortInfo: SortByItemType) => {
    setSortInfo(mergeSortInfoWithDefault(sortInfo));
  };

  useEffect(() => {
    if (sortInfoOutter) {
      setSortInfo(mergeSortInfoWithDefault(sortInfoOutter));
    }
  }, [sortInfoOutter]);

  return {
    sortInfo,
    onSortChange: handleSortChange,
    getSortedRecords,
  };
}
